/**
 * HA-772 — which Stripe Terminal readers the Staff Terminal looks for. This was hard-coded to
 * `simulated: true` ("set false in prod"), so a production build could only ever find simulated
 * readers and never take a real card (HA-139).
 *
 * <p>It is runtime config, not a build flag: `VITE_STRIPE_TERMINAL_SIMULATED` is filled into the
 * image's `window.env` at container start, like the other `VITE_` values, so one image serves
 * every environment.
 *
 * <p><b>Simulated only when asked for, exactly.</b> Anything but `"true"` — unset, blank, `"false"`,
 * a typo — means real readers. A production that forgets the variable therefore still takes real
 * cards; the environments that want simulated readers (dev, e2e, a test-cards staging) must say so.
 */
export function terminalDiscoveryConfig(value?: string): {
	simulated: boolean;
} {
	// `unknown`, not `string`: Vite types every env key as a string, but an unset one is undefined
	// at runtime, and a check typed on the promise would throw on exactly the production case.
	const setting: unknown =
		value ?? import.meta.env.VITE_STRIPE_TERMINAL_SIMULATED;

	return {
		simulated: typeof setting === "string" && setting.trim() === "true",
	};
}
